import { DEFAULT_PAGE_SIZE, MAX_PAGE_SIZE } from '@weft/types';
import { oz } from '@weft/utils';

export const PaginationLimitSchema = oz.number().max(MAX_PAGE_SIZE).optional().default(DEFAULT_PAGE_SIZE);